import { MapFromSierraAddress } from "../plugins/address-helper";
import { ApplicationInfo } from "./application_info";
import { SessionInfo } from "./session_info";
import { UserData } from "./user_data";

export const ProfileReadOnlyFields = [
  "person_code",
  "first_name",
  "last_name",
  "local_gov"
];

export type ProfileData = {
  app_id: string,
  registration_code?: string,
  person_code: string,
  full_name: string,
  parent_first_name: string,
  parent_last_name: string,
  parent_person_code: string,
  parent_email: string,
  create_or_update_password: boolean,
  password: string,
  repeat_password: string,
  field_values: { [key: string]: any },
  identities: string[] | null,
  account_exists: boolean,
  local_gov: string
  local_gov_date: string
  has_pending_special_application: boolean,
  has_special_rights: boolean,
  special_rights_end_date: string,
  special_rights_files?: SpecialRightsFile[],
  request_special_rights: boolean
}

export type SpecialRightsFile = {
  name: string,
  data: string | ArrayBuffer | null,
  size: number
}

export const createProfileData = async (
  session: SessionInfo,
  person_code: string,
  userData: UserData | null,
  forUnderage: boolean
) => {
  const gov = userData?.field_values["local_gov"] ?? null;
  const gov_date = userData?.field_values["local_gov_date"] ?? null;

  let ret = {
    app_id: session.application?.appId ?? "",
    registration_code: session.registration?.registrationCode,
    person_code: forUnderage ? "" : person_code,
    parent_first_name: "",
    parent_last_name: "",
    parent_person_code: forUnderage ? person_code : "",
    parent_email: "",
    create_or_update_password: false,
    password: "",
    repeat_password: "",
    field_values: {},
    identities: userData?.identities,
    account_exists: userData?.account_exists ?? false,
    local_gov: gov,
    local_gov_date: gov_date,
    has_pending_special_application: userData?.has_pending_special_application,
    has_special_rights: userData?.has_special_rights
  } as ProfileData;

  if (session.registration != null) {
    let firstName = "";
    let lastName = "";
    let personCode = "";
    let email = "";
    for (let f of session.registration.regFields) {
      if (f.name === "local_gov" && !forUnderage) {
        ret.field_values[f.name] = gov;
        continue;
      }

      let val: any = "";
      if (f.type == "multi_choice" || f.type == "multi_choice_checkbox") {
        val = [];
      }
      else if (f.type == "single_choice_dropdown") {
        val = null;
      }
      if (userData) {
        switch (f.name) {
          case "first_name":
            firstName = userData.field_values[f.name];
            break;
          case "last_name":
            lastName = userData.field_values[f.name];
            break;
          case "person_code":
            personCode = userData.field_values[f.name];
            break;
          case "email":
            email = userData.field_values[f.name];
            break;
          default:
            break;
        }

        if (userData.field_values[f.name] && !forUnderage) {
          if (f.type == "date") {
            let d = new Date(userData.field_values[f.name]);
            ret.field_values[f.name] = d.toString() === "Invalid Date" ? "" : d;
            continue;
          }
          else if (f.type == "address") {
            val = await MapFromSierraAddress(userData.field_values[f.name]);
          }
          else if (f.type == "multi_choice" || f.type == "multi_choice_checkbox") {
            if (userData.field_values[f.name]) {
              val = userData.field_values[f.name]
                .split("$$")
                .filter((x: string) => x && x.trim().length > 0)
                .map((x: string) => {
                  return {
                    value: x,
                    label: x
                  };
                });
            }
          }
          else if (f.type == "single_choice_dropdown") {
            const savedValue = userData.field_values[f.name];
            if (savedValue) {
              val = {
                value: savedValue,
                label: savedValue
              };
            }
          }
          else
          val = userData.field_values[f.name];
        }
      }
      ret.field_values[f.name] = val;
    }

    if (forUnderage) {
      ret.full_name = "";
      ret.parent_first_name = firstName;
      ret.parent_last_name = lastName;
      ret.parent_person_code = personCode;
      ret.parent_email = email;
    }
    else {
      ret.person_code = personCode;
      ret.full_name = `${firstName} ${lastName}`.trim();
      ret.parent_first_name = userData?.parent_first_name ?? "";
      ret.parent_last_name = userData?.parent_last_name ?? "";
      ret.parent_person_code = userData?.parent_person_code ?? "";
      ret.parent_email = userData?.parent_email ?? "";
    }
  }

  return ret;
}
